<table class="totals-table" *ngIf="tableData">
  <thead>
    <ng-container *ngFor="let item of tableData.header">
      <ng-container *ngTemplateOutlet="row; context: {item}"></ng-container>
    </ng-container>
  </thead>
  <tbody>
    <ng-container *ngFor="let item of tableData.body">
      <ng-container *ngTemplateOutlet="row; context: {item}"></ng-container>
    </ng-container>
  </tbody>
  <tfoot>
    <ng-container *ngFor="let item of tableData.footer">
      <ng-container *ngTemplateOutlet="row; context: {item}"></ng-container>
    </ng-container>
  </tfoot>
</table>

<ng-template #row let-item="item">
  <tr [ngClass]="{'prefix': item.isPrefix}">
    <th class="align-left" [colSpan]="item.type !== 'no-value' ? 1 : 2">
      <div *ngIf="item.title?.length">
        {{ item.title | translateValue }}
      </div>
      {{ item.label | translateValue }}<ng-container *ngIf="item.subValue?.length"> ({{ item.subValue }})</ng-container><ng-container *ngIf="item.type !== 'no-value'">:</ng-container>
    </th>
    <td class="align-right" *ngIf="item.type !== 'no-value'">
      <span class="price">{{ item.useDash ? '-' : (item.type === 'amount' ? (item.value | quantityInPcs) : (item.value | price)) }}</span>
    </td>
  </tr>
</ng-template>
